// client/src/components/Finances/EquityStats.js

export default function EquityStats({ equitySummary, projection }) {
  if (!equitySummary) {
    return (
      <div className="bg-white shadow rounded-xl p-6 text-sm text-gray-500">
        No equity data available.
      </div>
    );
  }

  const safe = (n) => Number(n || 0).toLocaleString();

  const {
    equity,
    valuation,
    mortgage
  } = equitySummary;

  // -----------------------------
  // PROJECTIONS (optional)
  // -----------------------------
  const projected5yr = projection?.[projection.length - 1]?.equity ?? null;

  const annualizedGrowth =
    projected5yr && equity
      ? (((projected5yr / equity) ** (1 / 5)) - 1) * 100
      : null;

  return (
    <div className="bg-white shadow rounded-xl p-6">
      <h3 className="font-semibold mb-4 text-gray-800">Equity Overview</h3>

      <div className="space-y-3 text-sm">

        {/* Current Property Value */}
        <p>
          <span className="text-gray-500">Current Property Value: </span>
          <span className="font-semibold">
            ${safe(valuation?.estimate)}
          </span>
        </p>

        {/* Mortgage Balance */}
        <p>
          <span className="text-gray-500">Mortgage Balance: </span>
          <span className="font-semibold">
            ${safe(mortgage?.balance)}
          </span>
        </p>

        {/* Net Equity */}
        <p>
          <span className="text-gray-500">Current Equity: </span>
          <span className="font-semibold text-blue-600">
            ${safe(equity)}
          </span>
        </p>

        {/* Projected Equity (if chart data exists) */}
        {projected5yr && (
          <p>
            <span className="text-gray-500">Projected 5-Year Equity: </span>
            <span className="font-semibold text-green-600">
              ${safe(projected5yr)}
            </span>
          </p>
        )}

        {/* Annual Growth Rate */}
        {annualizedGrowth && (
          <p>
            <span className="text-gray-500">Equity Annualized Growth: </span>
            <span className="font-semibold text-green-700">
              {annualizedGrowth.toFixed(1)}%
            </span>
          </p>
        )}

        {/* Placeholder if projection missing */}
        {!projected5yr && (
          <p className="text-xs text-gray-400 mt-3">
            Add projection data to display 5-year equity trends.
          </p>
        )}

      </div>
    </div>
  );
}
